import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'maplibre-gl/dist/maplibre-gl.css';
import './styles/theme.css';
import './styles/gate.css';
import './styles/ultratech.css';
import { App } from './App';
import { loadServerCredentials } from './map/providers';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');
const root = createRoot(container);
const paint = (): void =>
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
paint();
void loadServerCredentials().then(paint);
